import { css } from 'lit';

export const landingStyles = css`
  :host {
    display: block;
    font-family: var(--sl-font-sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
    line-height: 1.6;
    min-height: 100vh;
    width: 100%;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .landing-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-50, #f8fafc);
    width: 100%;
  }

  /* Header */
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 100;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .logo-image {
    width: 32px;
    height: 32px;
    border-radius: var(--sl-border-radius-medium);
  }

  .logo-text {
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--sl-color-primary-600, #3b82f6);
  }

  .nav-links {
    display: flex;
    gap: 2rem;
    align-items: center;
  }

  .nav-link {
    color: var(--sl-color-neutral-700, #374151);
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    transition: color 0.2s;
  }

  .nav-link:hover {
    color: var(--sl-color-primary-600, #3b82f6);
  }

  .nav-link.active {
    color: var(--sl-color-primary-600, #3b82f6);
    font-weight: 600;
  }


  .header-actions {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  .features-modal::part(panel) {
    max-width: 900px;
    padding: 1.5rem;
  }

  .feature-screenshot {
    border-radius: 14px;
    box-shadow: var(--sl-shadow-large, 0 25px 50px -12px rgba(15, 23, 42, 0.45));
    width: 100%;
    max-width: 420px;
    max-height: 360px;
    object-fit: cover;
    flex: 1 1 320px;
  }

  .feature-panel {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  sl-tab-panel::part(base) {
    padding: 0;
  }

  .feature-panel-content {
    flex: 1 1 360px;
    display: grid;
    gap: 1rem;
  }

  .feature-panel-content h3 {
    font-size: 1.6rem;
    margin-bottom: 0.25rem;
    color: var(--sl-color-neutral-900);
  }

  .feature-panel-content h4 {
    font-size: 1.05rem;
    font-weight: 700;
    margin: 0;
    color: var(--sl-color-neutral-800);
  }

  .feature-panel-content ul {
    margin: 0;
    padding-left: 1.2rem;
    display: grid;
    gap: 0.45rem;
    color: var(--sl-color-neutral-600);
  }

  .feature-panel-content div {
    display: grid;
    gap: 0.35rem;
  }

  .feature-panel-meta {
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }

  .contact-section {
    padding: 4rem 2rem;
    background: white;
  }

  .contact-container {
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2rem;
    align-items: start;
  }

  .contact-copy h2 {
    font-size: 2.25rem;
    font-weight: 700;
    color: var(--sl-color-neutral-900);
    margin-bottom: 1rem;
  }

  .contact-copy p {
    color: var(--sl-color-neutral-600);
    font-size: 1.05rem;
    line-height: 1.6;
  }

  .contact-copy a {
    color: var(--sl-color-primary-600, #3b82f6);
    font-weight: 600;
    text-decoration: none;
  }

  .contact-copy a:hover {
    text-decoration: underline;
  }

  .contact-form {
    display: grid;
    gap: 1rem;
    background: var(--sl-color-neutral-50);
    padding: 2rem;
    border-radius: 16px;
    border: 1px solid var(--sl-color-neutral-200);
    box-shadow: var(--sl-shadow-medium);
  }

  .contact-form label {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }

  .contact-form input,
  .contact-form textarea {
    padding: 0.75rem 1rem;
    border-radius: 10px;
    border: 1px solid var(--sl-color-neutral-200);
    font-size: 1rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    font-family: inherit;
  }

  .contact-form input:focus,
  .contact-form textarea:focus {
    outline: none;
    border-color: var(--sl-color-primary-400);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }

  .contact-form textarea {
    min-height: 140px;
    resize: vertical;
  }

  .contact-status {
    font-size: 0.95rem;
    font-weight: 600;
  }

  .contact-status.success {
    color: var(--sl-color-success-600, #16a34a);
  }

  .contact-status.error {
    color: var(--sl-color-danger-600, #dc2626);
  }

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .btn-primary {
    background: var(--sl-color-primary-600, #3b82f6);
    color: white;
  }

  .btn-primary:hover {
    background: var(--sl-color-primary-700, #2563eb);
    transform: translateY(-1px);
  }

  .btn-secondary {
    background: transparent;
    color: var(--sl-color-primary-600, #3b82f6);
    border: 1px solid var(--sl-color-primary-600, #3b82f6);
  }

  .btn-secondary:hover {
    background: var(--sl-color-primary-50, #eff6ff);
  }

  /* Hero Section */
  .hero {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 6rem 2rem 4rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    min-height: calc(100vh - 80px);
  }

  .hero-content {
    flex: 1;
    max-width: 600px;
  }

  .hero-title {
    font-size: 3.5rem;
    font-weight: 700;
    line-height: 1.1;
    color: var(--sl-color-neutral-900);
    margin-bottom: 1.5rem;
  }

  .hero-subtitle {
    font-size: 1.25rem;
    color: var(--sl-color-neutral-600);
    margin-bottom: 2rem;
    line-height: 1.6;
  }

  .hero-actions {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .hero-image {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }

  .slideshow-wrapper {
    width: 100%;
    max-width: 500px;
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: var(--sl-shadow-large);
  }

  /* Features Section */
  .features {
    padding: 4rem 2rem;
    background: white;
  }

  .features-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .features-header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .features-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--sl-color-neutral-900);
    margin-bottom: 1rem;
  }

  .features-subtitle {
    font-size: 1.125rem;
    color: var(--sl-color-neutral-600);
    max-width: 600px;
    margin: 0 auto;
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
  }

  .feature-card {
    padding: 2rem;
    border-radius: 12px;
    background: var(--sl-color-neutral-50);
    border: 1px solid var(--sl-color-neutral-200);
    transition: all 0.3s ease;
  }

  .feature-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--sl-shadow-large);
    border-color: var(--sl-color-primary-200);
  }

  .feature-icon {
    width: 48px;
    height: 48px;
    background: var(--sl-color-primary-100);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  .feature-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
    margin-bottom: 0.75rem;
  }

  .feature-description {
    color: var(--sl-color-neutral-600);
    line-height: 1.6;
  }

  .features-actions {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }

  /* CTA Section */
  .cta {
    padding: 4rem 2rem;
    background: linear-gradient(135deg, var(--sl-color-primary-600), var(--sl-color-primary-700));
    color: white;
    text-align: center;
  }

  .cta-container {
    max-width: 800px;
    margin: 0 auto;
  }

  .cta-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .cta-subtitle {
    font-size: 1.125rem;
    margin-bottom: 2rem;
    opacity: 0.9;
  }

  .cta-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
  }

  .btn-white {
    background: white;
    color: var(--sl-color-primary-600);
  }

  .btn-white:hover {
    background: var(--sl-color-neutral-100);
  }

  .btn-outline-white {
    background: transparent;
    color: white;
    border: 1px solid white;
  }

  .btn-outline-white:hover {
    background: white;
    color: var(--sl-color-primary-600);
  }

  /* Footer */
  .footer {
    background: var(--sl-color-neutral-900);
    color: var(--sl-color-neutral-300);
    padding: 3rem 2rem 2rem;
  }

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
  }

  .footer-section h3 {
    color: white;
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-links li {
    margin-bottom: 0.5rem;
  }

  .footer-links a {
    color: var(--sl-color-neutral-300);
    text-decoration: none;
    transition: color 0.2s;
  }

  .footer-links a:hover {
    color: white;
  }

  .footer-bottom {
    border-top: 1px solid var(--sl-color-neutral-700);
    margin-top: 2rem;
    padding-top: 2rem;
    text-align: center;
    color: var(--sl-color-neutral-400);
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .header {
      padding: 1rem;
      flex-wrap: wrap;
    }

    .nav-links {
      display: none;
    }

    .hero {
      flex-direction: column;
      text-align: center;
      padding: 4rem 1rem 2rem;
      gap: 2rem;
    }

    .hero-title {
      font-size: 2.5rem;
      line-height: 1.2;
    }

    .hero-actions {
      justify-content: center;
      flex-wrap: wrap;
    }

    .hero-image {
      order: -1;
      padding: 1rem;
    }

    .slideshow-wrapper {
      height: 300px;
    }

    .features-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    .feature-card {
      padding: 1.5rem;
    }

    .cta-actions {
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }

    .btn {
      width: 100%;
      max-width: 300px;
      justify-content: center;
    }

    .footer-container {
      grid-template-columns: 1fr;
      text-align: center;
    }

    .contact-container {
      grid-template-columns: 1fr;
    }

    .contact-form {
      padding: 1.5rem;
    }

    .contact-copy h2 {
      font-size: 2rem;
    }
  }
`;
